import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnPeoplePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M15.72 10.412H21m-2.58-2.64v5.28m-9.227 1.895c-3.34 0-6.193.51-6.193 2.552s2.835 2.57 6.193 2.57c3.34 0 6.192-.51 6.192-2.552 0-2.04-2.834-2.57-6.192-2.57m-.145-2.82c2.28 0 4.129-1.835 4.129-4.098s-1.849-4.097-4.13-4.097c-2.279 0-4.127 1.834-4.127 4.097-.008 2.255 1.827 4.09 4.1 4.097z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnPeoplePlus;
